module.exports = __webpack_public_path__ + "media/images/xpass/icons/brands/yogasix-335859459dc8d725ce003823eb5a4072.png";